class AMC_Solutions {
    constructor(el) {
        this.el = el;
        this.navbar = el.find('.solutions__nav .owl-carousel');
        this.navitems = el.find('button.solutions__navicon');
        this.tabsContainer = el.find('.solutions__tabs');
        this.tabs = el.find('.solutions__tab');
        this.bgscontainer = el.find('.solutions__bg');
        this.bgs = el.find('.solutions__bg > div');
        
        this.state = {
            carosuelInited: false,
            lazylodenabled: false,
            lazyloded: false
        }

        this.init();
    }


    nav() {
        let self = this;

        let debounced = _.debounce(function () {
            if (window.innerWidth < 1200 && ! self.state.carosuelInited) {
                self._initCarousel();
            }

            if (window.innerWidth >= 1200 && self.state.carosuelInited) {
                self._destroyCarousel();
            }
        }, 250);

        debounced();
        $(window).on('resize orientationchange', debounced);
    }

    events() {
        let self = this;
        this.navitems.on('click', function (e) {
            e.preventDefault();
            self.switchTab($(this));

            if (self.state.lazylodenabled && ! self.state.lazyloaded) {
                self.bgs.addClass('loaded');
                self.state.lazyloaded = true;
            }
        });

        this.navitems.eq(0).trigger('click');
        this.state.lazylodenabled = true;
    }

    _initCarousel() {
        let self = this;

        this.carousel = this.navbar.owlCarousel({
            nav: true, 
            dots: false,
            navText: ['<i class="icon-button-arrow">', '<i class="icon-button-arrow">'],
            loop: false,
            dots: false,
            responsive: {
                320: {
                    items: 1
                },
                560: {
                    items: 2
                },
                720: {
                    items: 3
                },
                960: {
                    items: 4
                }
            }
        });

        this.state.carosuelInited = true;
    }

    _destroyCarousel() {
        this.carousel.trigger('destroy.owl.carousel');
        this.state.carosuelInited = false;
    }

    switchTab(navitem) {
        let self = this;
        let index = navitem.data('index');
        let tgt = self.tabsContainer.find('[data-index="' + index + '"]');

        self.navitems.removeClass('active');
        navitem.addClass('active');

        self.tabs.removeClass('active');
        tgt.addClass('active');

        self.bgs.removeClass('active');
        self.bgs.filter('.bg-' + index).addClass('active');

        self.tabsContainer.css({
            height: tgt.outerHeight()
        });

        let debounced = _.debounce(function () {
            self.tabsContainer.css({
                height: tgt.outerHeight()
            });
        });

        $(window).on('resize orientationchange', debounced);
    }

    init() {
        this.nav();
        this.events();
    }
}